<div class="grid">
  <header class="grid__col-12 guts-m-t-4" *ngIf="source !== 'org'">
    <h2 class="h2">{{ i18n.dgDownloadableReports_DownloadableReports }}</h2>
  </header>

  <div class="grid__col-12">
    <div class="l_flex--align-right">
      <button
        df-button
        dfButtonType="primary"
        (click)="generateReport()"
        data-dgat="overview-c7f"
        [disabled]="isLoading"
      >
        <div class="l_flexbar gap-full-half">
          <df-icon icon="plus"></df-icon>
          <div>{{ i18n.dgDownloadableReports_GenerateReport }}</div>
        </div>
      </button>
    </div>
  </div>
</div>

<dgx-data-table
  [isLoading]="isLoading"
  [columns]="columns"
  [items]="reports"
></dgx-data-table>

<dgx-footer-glasses></dgx-footer-glasses>

<ng-template #groupNameColumn let-item>
  <span
    *ngFor="let group of item.reportParameters.groupNameList; let last = last"
    data-dgat="downloadable-reports-eea"
    >{{ group.groupName + (last ? '' : ', ') }}</span
  >
</ng-template>

<ng-template #dateRangeColumn let-item>
  <span
    >{{ item.reportParameters.startDate | date }} -
    {{ item.reportParameters.endDate | date }}</span
  >
</ng-template>

<ng-template #dateCreatedColumn let-item>
  <span>{{ item.startDate | date }}</span>
</ng-template>

<ng-template #reportStatusColumn let-item>
  <ng-container [ngSwitch]="item.reportStatus">
    <ng-container *ngSwitchCase="'Generate'">
      <button
        df-button
        dfButtonType="clear"
        class="color-blue guts-p-v-half guts-p-h-1"
        (click)="generateReport()"
        data-dgat="overview-e06"
      >
        <df-icon icon="plus" size="small" class="guts-m-r-half"></df-icon>
        <span class="ib-v-middle">{{
          i18n.dgDownloadableReports_Generate
        }}</span>
      </button>
    </ng-container>

    <ng-container *ngSwitchCase="'Download'">
      <a
        df-button
        dfButtonType="clear"
        class="color-blue guts-p-v-half guts-p-h-1"
        [href]="getReportDownloadUrl(item)"
        (click)="trackReportDownload(item)"
        target="_blank"
        data-new="andres"
        data-dgat="overview-fe6"
      >
        <df-icon
          icon="arrow-down-tray"
          size="small"
          class="guts-m-r-half"
        ></df-icon>
        <span class="ib-v-middle">{{
          i18n.dgDownloadableReports_Download
        }}</span>
      </a>
    </ng-container>

    <!-- InProgress, Unknown -->
    <ng-container *ngSwitchDefault>
      <div class="guts-p-v-half guts-p-h-1">
        <div class="ib-v-middle rel guts-m-r-1 color-ebony-a25">
          <df-spinner spinnerContext="button"></df-spinner>
        </div>
        <span class="ib-v-middle">{{
          i18n.dgDownloadableReports_Generating
        }}</span>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
